import React, {useState, useContext, Fragment, useCallback} from 'react';
import classnames from 'classnames';
import {Dropdown} from '@homeaway/react-dropdown';
import {TrackingContext} from '@homeaway/react-event-tracking';
import MultiUnitListWrapper from '../MultiUnitListWrapper/MultiUnitListWrapper';
import {MULTI_UNIT_BUTTON_CLICK} from '../utils/edap';

import './MultiUnitDropdown.less';

const MULTIPLE_UNITS_DROPDOWN_HEIGHT = 288;

const MultiUnitDropdown = ({
    currency,
    inputParams,
    isDatelessSearch,
    isMetric,
    propertyName,
    listing,
    showDesktopView,
    clientLogger,
    messages
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const context = useContext(TrackingContext);

    const onDropdownShow = useCallback(() => {
        context.trigger(MULTI_UNIT_BUTTON_CLICK, listing);
        setIsOpen(true);
    }, [context, listing]);

    const onDropdownHide = () => {
        setIsOpen(false);
    };

    const dropdownClass = classnames('MultiUnit__dropdown', {
        MultiUnitDropdown__Open: isOpen
    });

    return (
        <div className="MultiUnitDropdown" aria-label={propertyName}>
            <Dropdown
                className={dropdownClass}
                maxHeight={MULTIPLE_UNITS_DROPDOWN_HEIGHT}
                label={messages.multipleUnitsButtonLabel}
                id="multi-unit-dropdown"
                dropdownRight
                open={isOpen}
                onDropdownShow={onDropdownShow}
                onDropdownHide={onDropdownHide}
            >
                {isOpen && (
                    <Fragment>
                        <MultiUnitListWrapper
                            context="dropdown"
                            currency={currency}
                            inputParams={inputParams}
                            isMetric={isMetric}
                            isDatelessSearch={isDatelessSearch}
                            listing={listing}
                            propertyName={propertyName}
                            onDropdownHide={onDropdownHide}
                            isOpen={isOpen}
                            showDesktopView={showDesktopView}
                            clientLogger={clientLogger}
                            messages={messages}
                        />
                    </Fragment>
                )}
            </Dropdown>
        </div>
    );
};

export default MultiUnitDropdown;
